import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(5)
  },

  panel: {
    background: palette.neutral[400],
    padding: spacing(2),
    color: palette.neutral[100],
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
  },
  line: {
    display: 'flex',
    background: palette.neutral[500],
    padding: spacing(2),
    borderRadius: '4px',
  },

  item: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
    padding: spacing(1)
  },
}));

export default useStyles;
